import { buildAccessState } from '@/utils/guard';

export default function access(initialState: any) {
  return buildAccessState(initialState);
}
